export const small = "small";
export const normal = "normal";
export const large = "large";
